import Leaderboard from './leaderboards';
import Drawer from './drawer';
import Jackpots from './jackpots';
import RealityCheck from './realityCheck';
import GameHistory from "./gameHistory";
import Notification from './notifications';
import NotificationsHub from './notificationsHub';
import Campaigns from './campaigns';
import GameRecommendations from './gameRecommendations';
import ClientSync from './clientSync';
import BigTicketBonanzaGame from './bigTicketBonanzaGame';
import BigTicketBonanzaApp from './bigTicketBonanzaApp';
import FuzeGamesGame from './fuzeGamesGame';
import FuzeGamesApp from './fuzeGamesApp';
import AggIntegrations from './aggIntegrations';
import SuperWheel from './superWheel';

export default class Modules {
    constructor(api) {
        this.api = api;

        this.drawer = new Drawer(api);
        this.leaderboard = new Leaderboard(api);
        this.jackpots = new Jackpots(api);
        this.realityCheck = new RealityCheck(api);
        this.gameHistory = new GameHistory(api);
        this.notification = new Notification(api);
        this.notificationsHub = new NotificationsHub(api);
        this.campaigns = new Campaigns(api);
        this.gameRecommendations = new GameRecommendations(api);
        this.clientSync = new ClientSync(api);
        this.bigTicketBonanzaGame = new BigTicketBonanzaGame(api);
        this.bigTicketBonanzaApp = new BigTicketBonanzaApp(api);
        this.fuzeGamesGame = new FuzeGamesGame(api);
        this.fuzeGamesApp = new FuzeGamesApp(api);
        this.aggIntegrations = new AggIntegrations(api);
        this.superWheel = new SuperWheel(api);

        this.quee = [];
        this.queeTimeout();

        this.existingInstances = {};
        this.fuzeGamesGameInstance = undefined;
    }

    queeTimeout() {
        setTimeout(() => {
            if (this.api.drawer) {
                this.clearQuee();
            } else {
                this.queeTimeout();
            }
        }, 100);
    }

    clearQuee() {
        this.quee.forEach((i) => {
            this.initiateInstance(i);
        })
    }

    initiateInstance(instance) {
        // check if already existing ... can happen on reconnect
        if (this.existingInstances[instance.module] && this.existingInstances[instance.module][instance.instance]) {
            return;
        }
    
        switch (instance.module) {
            case "drawer":
                if (!this.api.queryParams.restricted) {
                    this.drawer.init(instance);
                }
                break;
            case "client_sync":
                if (this.api.drawer) {
                    this.clientSync.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }
                break;
            case "leaderboards":
                if (this.api.drawer) {
                    this.leaderboard.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }
                break;
            case "reality_check":
                this.realityCheck.init(instance);

                break;
            case "game_history":
                this.gameHistory.init(instance);

                break;
            case "jackpots":
                if (this.jackpots.instance) {
                    return
                }
                if (this.api.drawer) {
                    this.jackpots.instance = instance
                    this.jackpots.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }

                break;
            case "notifications":
                this.notification.init(instance);

                break;
            case "agg_integrations":
                this.aggIntegrations.init(instance);

                break;
            case "notifications_hub":
                if (this.api.drawer) {
                    this.notificationsHub.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }

                break;
            case "campaigns":
                if (this.api.drawer) {
                    this.campaigns.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }

                break;
            case "game_recommendations":
                if (this.api.drawer) {
                    this.gameRecommendations.init(instance);
                } else {
                    this.quee.push(instance);
                    return;
                }

                break;
            case "big_ticket_bonanza":
                if (this.api.drawer) {
                    this.bigTicketBonanzaGame.init(instance);
                    setTimeout(()=> {
                        this.bigTicketBonanzaApp.init(instance);
                    },0)
                } else {
                    const exist = this.quee.find(e => e.instance === "big_ticket_bonanza" )
                    if (!exist) {
                        this.quee.push(instance);
                    }
                    return;
                }

                break;
            case "fuze_games":          
                if (this.api.drawer) {
                    this.fuzeGamesApp.init(instance);
                } else {
                    const exist = this.quee.find(e => e.instance === "fuze_games" )
               
                    if (!exist) {
                        this.quee.push(instance);
                    }
                    return;
                }

                break;
            case "fuze_games_game":
                if (this.api.drawer) {
                    this.fuzeGamesGame.reset()
        
                    if (this.fuzeGamesGameInstance !== instance.instance) {
                        this.fuzeGamesGameInstance = instance.instance
                        setTimeout(()=> {
                            this.fuzeGamesGame.init(instance);
                        }, 100)
                    } else {
                        return
                    }
                } else {
        
                    const exist = this.quee.find(e => e.instance === "fuze_games_game" )
                
                    if (!exist) {
                        this.quee.push(instance);
                    }
                    return;
                }

                break;
            case "stakelogic_superwheel":
                this.superWheel.init(instance);
                break;
        }

        if (this.existingInstances[instance.module] === undefined) {
            this.existingInstances[instance.module] = {};
        }
        this.existingInstances[instance.module][instance.instance] = {};
    }
}
